import { render, staticRenderFns } from "./advertiser-disclosure.vue?vue&type=template&id=eee05380&"
import script from "./advertiser-disclosure.vue?vue&type=script&lang=js&"
export * from "./advertiser-disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports